<template>

	<div class="footer" v-if="!$store.state.app.embedMode">
		<h3><slot name="headline">Join more than 4,000,000 students & teachers on StudySync</slot></h3>
		<div class="cta">
			<slot name="cta">
				<btn><router-link :to="{name: 'freeTrial'}">Start a Free Trial</router-link></btn>
			</slot>
		</div>
	</div>

</template>

<script>

	export default {
		name: "FooterCTA",
		computed: {
			slotFilled() {
				return this.$slots.cta;
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import "media.scss";
	@import "responsive-font.scss";

	section {

	}

	.footer {
		background:#FDB913; padding:3.7rem 2.4rem 5rem; display:flex; flex-direction:column; justify-content:center; align-items:center; margin:0 auto;
		@include media(xlarge) {
			padding:7.2vw 5vw 8.125vw;
		}
	}
	h3 {
		@include responsive-font(40);
		text-align:center; font-size:2.5rem; line-height:1.25; font-weight:400; color:#ffffff; margin-bottom:2.9rem; text-transform:uppercase;
		@include media(small, large) {
			font-weight:400;
		}
		@include media(xlarge) {
			margin-bottom:2.01vw;
		}
	}
	.cta {
		display:flex;
		@include media(small, xlarge) {
			flex-direction:column;
		}
		/deep/ .btn {
			& + .btn {
				@include media(small, xlarge) {
					margin-top:.8rem;
				}
				@include media(xlarge) {
					margin-left:1.11vw;
				}
			}
			button, a {
				background:#ffffff; color:#FDB913;
			}
		}
	}



</style>



// WEBPACK FOOTER //
// src/components/FooterCTA.vue